import {Component, Vue, Watch, Mixins} from 'vue-property-decorator';
import { ServiceType } from '@/products-and-services/ProductsAndServicesModels';
import CrossSalesMixin from './CrossSalesMixin';
import {CrossSaleAudienceType} from "@/products-and-services/CrossSaleModels";

@Component
export default class ProductsServicesMixin  extends Mixins(CrossSalesMixin) {
              
    get serviceTypes(): ServiceType[] {
        const serviceTypes = this.$store.getters.getAvailableServices();
        if (serviceTypes) {
            return serviceTypes;
        }
        return [] as ServiceType[];
    }

    get isBusinessServices() {
        if (window.location.pathname.includes('residential')) {
            return false;
        }
        return true;
    }
}